import React, { useState } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import styles from './styles/faq.module.css'
import faqBackground from "../../../assets/images/Faq_bg.png"; 
import openIcon from "../../../assets/svgs/Vector 335.svg"; 
import closeIcon from "../../../assets/svgs/Vector 335-2.svg"; 

const FAQSection: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const faqs = [
    {
      question: "How do I create an account on BeatFussion?",
      answer: "Simply download the app on either App store or Playstore and sign up using your email or Google.",
    },
    {
      question: "What type of content can I find on BeatFussion?",
      answer: "You can find dance competitions, tutorials, and user-generated dance content.",
    },
    {
      question: "How can I participate in the dance competition?",
      answer: "Register on our platform, create a profile, and look for upcoming competitions to join.",
    },
    {
      question: "Can I interact with other users on BeatFussion?",
      answer: "Yes! You can follow, like, and comment on other users' dance videos.",
    },
    {
      question: "How can I contact customer support?",
      answer: "You can reach out to us via the contact form on the support page or through our social media channels.",
    },
  ];

  React.useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
      easing: 'ease-in-out',
      once: true, // Animation should only trigger once when in view
    });
  }, []);

  return (
    <section
      className="w-11/12 mx-auto mt-16 sm:mt-32 bg-purple-100 rounded-xl pt-16 pb-16 p-5 sm:p-16 shadow-md"
      style={{
        backgroundImage: `url(${faqBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      data-aos="fade-up"
    >
      <h2 className={`${styles.faqTitle} text-2xl lg:text-3xl font-bold text-left text-black mb-4`} data-aos="fade-down">
        Want to know more about Beat Fussion?
      </h2>
      <p className="text-left text-xl text-gray-700 mb-8" data-aos="fade-down" data-aos-delay="100">
        Do you have questions? We have the answers... Check out our FAQs for answers.
      </p>
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div key={index} className="bg-white rounded-lg shadow-md" data-aos="fade-up"
          data-aos-delay={`${index * 100}`}>
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full text-left flex justify-between items-center px-6 py-8 text-black font-medium text-xl"
            >
              {faq.question}
              <img
                src={activeIndex === index ? closeIcon : openIcon}
                alt={activeIndex === index ? "Close" : "Open"}
                className="w-3 h-3"
              />
            </button>
            {activeIndex === index && (
              <div className="px-6 pb-4 text-lg text-gray-700" data-aos="fade-in" data-aos-delay="200">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
